// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"9516f861","768":"e3f14ed9","845":"5b205c9b"}[chunkId] + ".chunk.js";
};